import { AfterViewInit, Component, Injector, OnInit, ViewChild } from '@angular/core';
import { GroupService } from 'tnx-admin-service/group/services';
import { SingleService } from 'tnx-admin-service/single/services';
import { ColumnSchemaBase, ComponentContextService, CrudListComponent, DataListBase, DataType, DropdownControlSchema, DropdownOptions, GridInfo, isLiteralObject, ModelSchema, Operator } from 'tnx-shared';
@Component({
    selector: 'app-single',
    templateUrl: './single.component.html',
    styleUrls: ['./single.component.scss'],
    providers: [ComponentContextService]
})
export class SingleComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    dataSourceGroup = [];
    selectedGroupId = '';

    constructor(
        protected _injector: Injector,
        protected _singleService: SingleService,
        protected _groupService: GroupService
    ) {
        super(_injector);
    }
    ngOnInit() {
        this.setting.objectName = 'danh mục';
        this.setting.baseService = this._singleService;

        this.modelSchema = [
            new ModelSchema({ field: 'sort', name: 'Sắp xếp', fullName: 'Sắp xếp', description: '' }),
            new ModelSchema({ field: 'code', name: 'Mã', fullName: 'Mã', description: '' }),
            new ModelSchema({ field: 'name', name: 'Tên', fullName: 'Tên', description: '' }),
            new ModelSchema({ field: 'groupCategoryId', name: 'Nhóm danh mục', fullName: 'Nhóm danh mục', description: '' }),
            new ModelSchema({ field: 'description', name: 'Mô tả', fullName: 'Mô tả', description: '' }),
            new ModelSchema({ field: 'used', name: 'Sử dụng', fullName: 'Sử dụng', description: '' })
        ];

        this.setting.cols = [
            new ColumnSchemaBase({
                field: 'code',
                label: this._translateService.instant('Mã'),
                fullTextSearch: true
            }),
            new ColumnSchemaBase({
                field: 'name',
                label: this._translateService.instant('Tên'),
                fullTextSearch: true
            }),
            new ColumnSchemaBase({
                field: 'sort',
                label: this._translateService.instant('Thứ tự')
            }),
            new ColumnSchemaBase({
                field: 'used',
                dataType: 'boolean',
                label: this._translateService.instant('Sử dụng')
            }),
            new ColumnSchemaBase({
                field: 'description',
                label: this._translateService.instant('Mô tả')
            })
        ];
        this.searchData.groupId = null;
        this.searchData.groupName = null;
        this.onGetValuesGroup();

        this.searchSchema.groupId = new DropdownControlSchema({
            label: 'Chọn nhóm danh mục',
            showClear: false
        });
        this.model.ready = false;
        super.ngOnInit();
    }

    handleFormReady(data) {
        this._triggerProcessData();
    }

    onGetValuesGroup() {
        let dataSourceOption = new DropdownOptions({
            valueField: 'id',
            displayField: 'name',
            sortField: 'sort',
            sortDir: 1,
        });
        this._groupService.getDataDropdown(dataSourceOption).then(groupDataSource => {
            this.dataSourceGroup = groupDataSource.map(
                x => <any>{ id: x.id, ten: x.name }
            );
            if (this.dataSourceGroup.length > 0) {
                this.searchData.groupId = this.dataSourceGroup[0].id;
                this.searchData.groupName = this.dataSourceGroup[0].ten;
                this.setting.objectName = `danh mục ${this.dataSourceGroup[0].ten.toLowerCase()}`;
                this.model.ready = true;
                this.selectedGroupId = this.dataSourceGroup[0].id;
            }
        });
    }


    onSelect(value) {
        const itemSelected = this.dataSourceGroup.find(item => item.id == value);
        if (itemSelected) {
            this.setting.objectName = `danh mục ${itemSelected.ten.toLowerCase()}`;
            this.selectedGroupId = value;
        }
        this._triggerProcessData();
    }

    async modifyGridInfo(gridInfo: GridInfo) {
        if (!isLiteralObject(this.searchData.groupId)) {
            gridInfo.filters.splice(0, 0,
                this.newFilter('groupCategoryId', Operator.equal, this.searchData.groupId)
            );
        } else {
            gridInfo.filters.splice(0, 0,
                this.newFilter('groupCategoryId', Operator.equal, this.searchData.groupId.id)
            );
        }
        gridInfo.sorts.splice(0, 0,
            { field: 'sort', dir: 1 }
        );
    }
}
